import { useDecodedQueryParamFilterValues } from '@aibees/elephant/feature/search-filters/hooks/use-decoded-query-param-filter-values';

export function useSelectedTreeOptions(
  field: string,
  customValue?: string
): string[] {
  return useDecodedQueryParamFilterValues(field!, customValue);
}
